<div *ngIf="errorMessage" id="screening-error" class="form-container">
  <div class="row">
    <div class="col-md-12 text-center">
      <p><i id="screeningErrorIcon" class="material-icons screeningIcon">error_outline</i></p>
      <p>Invalid Request:</p>
      <p>{{ errorMessage }}</p>
      <p> If you need further assistance please contact us at our dedicated resident services center at <b>855.676.1680</b>. Thank you.</p>
    </div>
  </div>
  <hr />
</div>

<div *ngIf="loading" class="flex flex-grow text-center h-full">
  <div>
    <div>

    </div>
    <div>

    </div>
    <div>

    </div>
    <div>

    </div>
    <div>

    </div>
    <div>

    </div>
    <div>

    </div>
    <div>

    </div>
  </div>
</div>
<div class="h-full" #documentSignContainer></div>
<br>
<br>


